import React from 'react'
import { Navigate } from 'react-router-dom'

// default layout
import Default from '../layouts/dashboard/default';

// Dashboard
import Index from '../views/dashboard/index'
import AlternateDashboard from '../views/dashboard/alternate-dashboard'

// icon pages
import Solid from '../views/dashboard/icons/solid';
import Outline from '../views/dashboard/icons/outline';
import DualTone from '../views/dashboard/icons/dual-tone';

// special pages
import Calender from '../views/dashboard/special-pages/calender';

// user pages
import Userprofile from '../views/dashboard/app/user-profile';

// extra
import Admin from '../views/dashboard/admin/admin';
import MaintenanceManager from '../views/dashboard/admin/MaintenanceManager';

// widget
import Widgetbasic from '../views/dashboard/widget/widgetbasic';
import Widgetchart from '../views/dashboard/widget/widgetchart';
import Widgetcard from '../views/dashboard/widget/widgetcard';


// form
import FormElement from '../views/dashboard/from/form-element';
import FormWizard from '../views/dashboard/from/form-wizard';
import FormValidation from '../views/dashboard/from/form-validation';

// table
import BootstrapTable from '../views/dashboard/table/bootstrap-table';
import TableData from '../views/dashboard/table/table-data';
import Borderedtable from '../views/dashboard/table/border-table';
import Fancytable from '../views/dashboard/table/fancy-table';
import FixedTable from '../views/dashboard/table/fixed-table';

//extra 
import PrivacyPolicy from '../views/dashboard/extra/privacy-policy'
import TermsofService from '../views/dashboard/extra/terms-of-service'
import BlankPage from '../views/dashboard/extra/blank-page'
import ShimmerComponent from '../views/dashboard/extra/ShimmerComponent'
import AdminAdd from '../views/dashboard/app/admin-add';
import AdminList from '../views/dashboard/app/admin-list';
import SuperAdminAdd from '../views/dashboard/app/superadmin-add';
import SuperAdminList from '../views/dashboard/app/superadmin-list';
import GroupList from '../views/dashboard/app/groups';
import UploadFiles from '../views/dashboard/upload/upload-files';
import Closures from '../views/dashboard/closures/Closures';
import MasterUploadFiles from '../views/dashboard/master-uploads/master-upload-files';

//reports

import BRCReport from '../views/dashboard/reports/BRCReport';
import IGSTReport from '../views/dashboard/reports/IGSTReport';
import DrawbackReport from '../views/dashboard/reports/DrawbackReport';
import ClearanceTimeImportReport from '../views/dashboard/reports/ClearanceTimeImportReport';
import ClearanceTimeExportReport from '../views/dashboard/reports/ClearanceTimeExportReport';
import RodtepReport from '../views/dashboard/reports/RodtepReport';
import FtaReport from '../views/dashboard/reports/FTAReport';
import FtaOppReport from '../views/dashboard/reports/FTAOppReport';
import FTAApplicabilityReport from '../views/dashboard/reports/FTAApplicabilityReport';
import BondReport from '../views/dashboard/reports/BondReport';
import AdvAuthDetailsReport from '../views/dashboard/reports/AdvanceAuthReport';
import AdvAuthDetailsBOEReport from '../views/dashboard/reports/AdvanceAuthLedgerReport';
import AdvanceAuthRdnLicReport from '../views/dashboard/reports/AdvanceAuthRdnLicReport';
import EPCGReportComponent from '../views/dashboard/reports/EPCGReport';
import RodetepScripLedger from '../views/dashboard/reports/RodtepScripLedgerReport';
import AdvLicImportExportReport from '../views/dashboard/reports/AdvLicImportExportReport';
import CIPOverview from '../views/frontpage-details/CIPOverview';
import KeyFeatures from '../views/frontpage-details/KeyFeatures';
import ContactUs from '../views/frontpage-details/ContactUs';
import Clients from '../views/frontpage-details/OurClients';
import OtherServices from '../views/frontpage-details/OtherServices';
import ReportTemplates from '../views/dashboard/report-templates/report_templates';
import DocumentLinks from '../views/dashboard/documents-links/document_links';
import ManageGraphs from '../views/dashboard/graphs/ManageGraphs';
import PageConfigurator from '../views/dashboard/PageConfigurator';
import GraphsDashboard from '../views/dashboard/graphs/GraphsDashboard';
import TradeSearch from '../views/dashboard/trade-search/TradeSearch';
import CCR from '../views/dashboard/reports/CCR';
import InconsistencyReport from '../views/dashboard/reports/InconsistencyReport';
import DutySavingReport from '../views/dashboard/reports/DutySavingReport';
import ConsolidatedReportView from '../views/dashboard/ConsolidatedReportView';

export const PublicFrontpageRouter = [
    {
        path: "/frontpage-details/CIPOverview",
        element: <CIPOverview />
    },
    {
        path: "/frontpage-details/KeyFeatures",
        element: <KeyFeatures />
    },
    {
        path: "/frontpage-details/ContactUs",
        element: <ContactUs />
    },
    {
        path: "/frontpage-details/OurClients",
        element: <Clients />
    },
    {
        path: "/frontpage-details/OtherServices",
        element: <OtherServices />
    }
];

export const DefaultRouter = [
    {
        path: "/",
        element: <Default />,
        children: [
            {
                path: "",
                element: <Navigate to="/dashboard/alternate-dashboard" replace />
            },
            {
                path: "dashboard",
                element: <AlternateDashboard />
            },
            {
                path: "dashboard/consolidated-report",
                element: <ConsolidatedReportView />
            },

            {
                path: "dashboard/alternate-dashboard",
                element: <Index />
            },
            {
                path: 'dashboard/graphs',
                element: <ManageGraphs />
            },
            {
                path: 'dashboard/graphs/display',
                element: <GraphsDashboard />
            },
            // Special Pages
            {
                path: 'dashboard/special-pages/calender',
                element: <Calender />
            },


            //User 
            {
                path: 'dashboard/app/user-profile',
                element: <Userprofile />
            },
            {
                path: 'dashboard/app/user-add',
                element: <AdminAdd />
            },
            {
                path: 'dashboard/app/superadmin-add',
                element: <SuperAdminAdd />
            },
            {
                path: 'dashboard/app/superadmin-list',
                element: <SuperAdminList />
            },

            {
                path: 'dashboard/reports/brc-report',
                element: <BRCReport />
            },
            {
                path: 'dashboard/reports/advauth-export-report',
                element: <AdvAuthDetailsReport />
            },
            {
                path: 'dashboard/reports/advauth-import-report',
                element: <AdvAuthDetailsBOEReport />
            },
            {
                path: 'dashboard/reports/adv-rdn-lic',
                element: <AdvanceAuthRdnLicReport />
            },
            {
                path: 'dashboard/reports/advauth-excess-import-report',
                element: <AdvLicImportExportReport />
            },
            {
                path: 'dashboard/reports/bond-report',
                element: <BondReport />
            },
            {
                path: 'dashboard/reports/drawback-report',
                element: <DrawbackReport />
            },
            {
                path: 'dashboard/reports/epcg-report',
                element: <EPCGReportComponent />
            },
            {
                path: 'dashboard/reports/rodtep-export-report',
                element: <RodtepReport />
            },
            {
                path: 'dashboard/reports/rodtep-import-report',
                element: <RodetepScripLedger />
            },
            {
                path: 'dashboard/reports/igst-report',
                element: <IGSTReport />
            },
            {
                path: 'dashboard/reports/clearance-time-import-report',
                element: <ClearanceTimeImportReport />
            },
            {
                path: 'dashboard/reports/clearance-time-export-report',
                element: <ClearanceTimeExportReport />
            },
            {
                path: 'dashboard/reports/fta-report',
                element: <FtaReport />
            },
            {
                path: 'dashboard/reports/fta-opp-report',
                element: <FtaOppReport />
            },
            {
                path: 'dashboard/reports/fta-applicability-report',
                element: <FTAApplicabilityReport />
            },
            {
                path: 'dashboard/reports/ccr',
                element: <CCR />
            },
            {
                path: 'dashboard/reports/inconsistency-report',
                element: <InconsistencyReport />
            },
            {
                path: 'dashboard/reports/duty-saving-report',
                element: <DutySavingReport />
            },
            //Upload
            {
                path: 'dashboard/upload/upload-files',
                element: <UploadFiles />
            },
            {
                path: 'dashboard/trade-search',
                element: <TradeSearch />
            },
            {
                path: 'dashboard/closure/create',
                element: <Closures />
            },
            // Admin
            {
                path: 'dashboard/admin/admin',
                element: <Admin />
            },
            {
                path: 'dashboard/admin/maintenance',
                element: <MaintenanceManager />
            },
            {
                path: 'dashboard/app/admin-add',
                element: <AdminAdd />
            },
            {
                path: 'dashboard/app/user-list',
                element: <AdminList />
            }, {
                path: 'dashboard/app/groups',
                element: <GroupList />
            },
            // report-templates
            {
                path: "dashboard/report-templates/create",
                element: <ReportTemplates />
            },
            // document-links
            {
                path: "/dashboard/documents/links",
                element: <DocumentLinks />
            },

            // master-uploads
            {
                path: "/dashboard/master-uploads",
                element: <MasterUploadFiles />
            },

            // page-configurations (superadmin only)
            {
                path: 'dashboard/page-config',
                element: <PageConfigurator />
            },

            // Ui-Color
            // Widgets
            {
                path: 'dashboard/widget/widgetbasic',
                element: <Widgetbasic />
            },
            {
                path: 'dashboard/widget/widgetchart',
                element: <Widgetchart />
            },
            {
                path: 'dashboard/widget/widgetcard',
                element: <Widgetcard />
            },

            // Form
            {
                path: 'dashboard/form/form-element',
                element: <FormElement />
            },
            {
                path: 'dashboard/form/form-wizard',
                element: <FormWizard />
            },
            {
                path: 'dashboard/form/form-validation',
                element: <FormValidation />
            },
            // Table
            {
                path: 'dashboard/table/bootstrap-table',
                element: <BootstrapTable />
            },
            {
                path: 'dashboard/table/table-data',
                element: <TableData />
            },
            {
                path: 'dashboard/table/border-table',
                element: <Borderedtable />
            },
            {
                path: 'dashboard/table/fancy-table',
                element: <Fancytable />
            },
            {
                path: 'dashboard/table/fixed-table',
                element: <FixedTable />
            },

            // Icon
            {
                path: 'dashboard/icon/solid',
                element: <Solid />
            },
            {
                path: 'dashboard/icon/outline',
                element: <Outline />
            },
            {
                path: 'dashboard/icon/dual-tone',
                element: <DualTone />
            },
            // extra-pages
            {
                path: 'dashboard/extra/privacy-policy',
                element: <PrivacyPolicy />
            },
            {
                path: 'dashboard/extra/terms-of-service',
                element: <TermsofService />
            },
            {
                path: 'dashboard/extra/blank-page',
                element: <BlankPage />
            },
            {
                path: 'dashboard/extra/ShimmerComponent',
                element: <ShimmerComponent />
            },
        ]
    },
]
